import React, { useEffect, useState } from 'react';


const skills = [
  { name: 'React.js', level: 92 },
  { name: 'Python', level: 95 },
  { name: 'ASP.NET MVC / C#', level: 98 },
  { name: 'JavaScript', level: 92 },
  { name: 'HTML/CSS', level: 95 },
  { name: 'Oracle', level: 88 },
  { name: 'SQL', level: 88 },
  { name: 'Ableton Live', level: 90 },
  { name: 'Flutter', level: 82 },
];

function Skills() {
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    setAnimated(true);
  }, []);

  return (
    <section id="skills" className="section">
      <h2>Skills</h2>
      <div className="skills-container">
        {skills.map((skill, index) => (
          <div key={index} className="skill-item">
            <div className="skill-info">
              <span className="skill-name">{skill.name}</span>
              <span className="skill-percentage">{skill.level}%</span>
            </div>
            <div className="skill-bar-container">
              <div 
                className={`skill-bar ${animated ? 'animate' : ''}`}
                style={{ width: animated ? `${skill.level}%` : '0%' }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;